import axios from "axios";
import { PlanDrugList, PlanDrugListHistory, PlanDrugListType } from "@/models/PlanDrugList";

export interface AddPlanDrugListRequest {
    drugSource: number;
    packageId: number;
    drugName?: string | null;
    ndc?: string | null;
    effectiveDate?: string | null;
    expirationDate?: string | null;
}

/**
 * Client for the per-plan drug lists (approved allow list + blocked deny list). Backed by CPHub.API
 * PlanDrugListController (route "api/PlanDrugList/{listType}/..."). The list type is carried in the route.
 */
export class PlanDrugListService {
    static async getByPlan(planId: number, listType: PlanDrugListType, includeInactive = false): Promise<PlanDrugList[]> {
        const { data } = await axios.get<PlanDrugList[]>(`/api/PlanDrugList/${listType}/${planId}`, {
            params: { includeInactive },
        });
        return data;
    }

    static async add(planId: number, listType: PlanDrugListType, request: AddPlanDrugListRequest): Promise<PlanDrugList> {
        const { data } = await axios.post<PlanDrugList>(`/api/PlanDrugList/${listType}/${planId}`, request);
        return data;
    }

    static async remove(id: number): Promise<void> {
        await axios.post(`/api/PlanDrugList/${id}/Remove`);
    }

    static async getHistory(planId: number, listType: PlanDrugListType, fromDate: Date, toDate: Date): Promise<PlanDrugListHistory[]> {
        const { data } = await axios.get<PlanDrugListHistory[]>(`/api/PlanDrugList/${listType}/${planId}/history`, {
            params: { fromDate, toDate },
        });
        return data;
    }
}
